import { useEffect, useRef } from "react";
import { toast } from "sonner";

const EVENTS = ["mousemove", "keydown", "click", "scroll", "touchstart"];

export default function useIdleLogout(onTimeout, idleMs = 15 * 60 * 1000, warnMs = 60 * 1000) {
  const last = useRef(Date.now());
  const warned = useRef(false);

  useEffect(() => {
    const bump = () => {
      last.current = Date.now();
      if (warned.current) {
        warned.current = false;
        toast.dismiss("idle-warning");
      }
    };
    EVENTS.forEach((e) => window.addEventListener(e, bump, { passive: true }));
    const timer = setInterval(() => {
      const idle = Date.now() - last.current;
      if (idle >= idleMs) {
        clearInterval(timer);
        onTimeout();
      } else if (idle >= idleMs - warnMs && !warned.current) {
        warned.current = true;
        toast.warning("You'll be signed out in 1 minute due to inactivity.", { id: "idle-warning", duration: warnMs });
      }
    }, 5000);
    return () => {
      EVENTS.forEach((e) => window.removeEventListener(e, bump));
      clearInterval(timer);
    };
  }, [onTimeout, idleMs, warnMs]);
}
